<template>
  <div class="hotspot" @click="openProductModal">
    <div class="hotspot-circle allow-touch">
      <BaseIcon icon="info-outline" class="size-26px allow-touch" />
    </div>
  </div>
  <BrochureHotspotProductModal
    v-if="activeHotspot === hotspot.id"
    :hotspot="hotspot"
  />
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import {
  type HotspotProductEntity,
  type HotspotLinkEntity,
  useCreateHotspotStatisticMutation,
  HotspotStatisticsType,
} from "~/graphql/generated";

const props = defineProps<{
  hotspot: HotspotProductEntity | HotspotLinkEntity;
}>();

const activeHotspot = useRouteQuery("offer");

// Hotspot statistics mutation
const deviceId = useDeviceId();
const hotspotStatisticMutation = useCreateHotspotStatisticMutation();
const openProductModal = () => {
  activeHotspot.value = props.hotspot.id;

  hotspotStatisticMutation.executeMutation({
    createHotspotStatistic: {
      deviceId: deviceId.value,
      hotspotId: props.hotspot.id,
      statisticsType: HotspotStatisticsType.ProductClick,
    },
  });
};

const x = ref(props.hotspot.x * 100 + "%");
const y = ref(props.hotspot.y * 100 + "%");
const width = ref(props.hotspot.width * 100 + "%");
const height = ref(props.hotspot.height * 100 + "%");
</script>

<style lang="scss" scoped>
.hotspot {
  position: absolute;
  z-index: 4;
  left: v-bind(x);
  top: v-bind(y);
  width: v-bind(width);
  height: v-bind(height);

  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  cursor: pointer;
  pointer-events: all;

  .hotspot-circle {
    width: 39px;

    aspect-ratio: 1/1;
    color: white;
    background-color: rgba($dark-100, 0.75);
    border-radius: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
